module.exports = __webpack_public_path__ + "ionicons.2c159d0d05473040b53e.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/ionicons/fonts/ionicons.woff?v=2.0.1
// module id = ../../../../ionicons/fonts/ionicons.woff?v=2.0.1
// module chunks = 13